<template>
  <div class="col-12" v-if="studioURL">
    <CompactEventsCalendar :studioURL="studioURL" :openInNewWindow="true" />
  </div>
</template>

<script>
import Vue from 'vue';
import CompactEventsCalendar from '@/web/components/events/CompactEventsCalendar';
import { getStudioURL } from '@/web/router/custom-domain-utils';

export default Vue.extend({
  name: 'WidgetCompactCalendar',
  components: {
    CompactEventsCalendar,
  },
  computed: {
    studioURL() {
      return getStudioURL(this.$route);
    },
  },
  mounted() {
    window.Intercom('update', { hide_default_launcher: true });
  },
});
</script>
